export * from './Router';
export * from './Link';
export * from './Route';
export * from './RouteNotFound';
export * from './Redirect';
export * from './SubRouter';
export { useLocation, useParams, useHistory } from './Hooks';

// issue on SubRouter when still mounted but changing consumer url  in effect matched is not false
